module.exports = __webpack_public_path__ + "static/media/vertex-6502x.602fb3fe.jpg";